import { getNetwork } from "../client/index.js";
class FaucetRateLimitError extends Error {
}
async function faucetRequest({ host, path, body, headers, method }) {
  const endpoint = new URL(path, host).toString();
  const res = await fetch(endpoint, {
    method,
    body: body ? JSON.stringify(body) : void 0,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  });
  if (res.status === 429) {
    throw new FaucetRateLimitError(
      `Too many requests from this client have been sent to the faucet. Please retry later`
    );
  }
  try {
    const parsed = await res.json();
    if (parsed.error) {
      throw new Error(`Faucet returns error: ${parsed.error}`);
    }
    return parsed;
  } catch (e) {
    throw new Error(
      `Encountered error when parsing response from faucet, error: ${e}, status ${res.status}, response ${res}`
    );
  }
}
async function requestIotaFromFaucetV0(input) {
  return faucetRequest({
    host: input.host,
    path: "/gas",
    body: {
      FixedAmountRequest: {
        recipient: input.recipient
      }
    },
    headers: input.headers,
    method: "POST"
  });
}
async function requestIotaFromFaucetV1(input) {
  return faucetRequest({
    host: input.host,
    path: "/v1/gas",
    body: {
      FixedAmountRequest: {
        recipient: input.recipient
      }
    },
    headers: input.headers,
    method: "POST"
  });
}
async function getFaucetRequestStatus(input) {
  return faucetRequest({
    host: input.host,
    path: `/v1/status/${input.taskId}`,
    headers: input.headers,
    method: "GET"
  });
}
const DEFAULT_MAX_FAUCET_ATTEMPTS = 20;
const DEFAULT_FAUCET_POLL_DELAY_MS = 1500;
async function requestIotaFromFaucet(input) {
  const maxAttempts = input.maxAttempts ?? DEFAULT_MAX_FAUCET_ATTEMPTS;
  const delayMs = input.delayMs ?? DEFAULT_FAUCET_POLL_DELAY_MS;
  const { error, task: taskId } = await requestIotaFromFaucetV1({
    recipient: input.recipient,
    host: input.host,
    headers: input.headers
  });
  if (error || !taskId) {
    throw new Error(error ?? "Failed, task id not found.");
  }
  let currentStatus = "INPROGRESS";
  let attempts = 0;
  while (currentStatus === "INPROGRESS") {
    const {
      status: { status, transferred_gas_objects },
      error: error2
    } = await getFaucetRequestStatus({
      host: input.host,
      taskId,
      headers: input.headers
    });
    currentStatus = status;
    if (currentStatus === "DISCARDED" || error2 || attempts > maxAttempts) {
      throw new Error(error2 ?? status ?? "Something went wrong");
    }
    if (currentStatus === "SUCCEEDED") {
      return transferred_gas_objects?.sent.reduce((total, { amount }) => total + amount, 0);
    }
    attempts += 1;
    await new Promise((resolve) => setTimeout(resolve, delayMs));
  }
  throw new Error("Something went wrong");
}
function getFaucetHost(network) {
  const requestedNetwork = getNetwork(network);
  if (!requestedNetwork.faucet) {
    throw new Error(`Unknown network: ${network}`);
  }
  return requestedNetwork.faucet;
}
function getFaucetWebsiteUrl(faucetWebsite, address) {
  const url = new URL(faucetWebsite);
  if (address) {
    url.searchParams.set("address", address);
  }
  return url.toString();
}
export {
  FaucetRateLimitError,
  getFaucetHost,
  getFaucetRequestStatus,
  getFaucetWebsiteUrl,
  requestIotaFromFaucet,
  requestIotaFromFaucetV0,
  requestIotaFromFaucetV1
};
//# sourceMappingURL=faucet.js.map
